import React, { useEffect, useMemo } from 'react';
import { WidgetProps } from '@rjsf/utils';
import { useAppSelector } from '@/redux/hooks';
import { selectAllProfiles } from '@/redux/selectors/profileSelectors';
import ProfileSelectionField from '@/components/OrderPlacement/OPStep1OrderDetails/ProfileSelectionField';

const CustomerProfilePickerWidget = (props: WidgetProps & { extraData: any }) => {
  const profiles = useAppSelector(selectAllProfiles);
  const customerName = props.extraData?.profile?.customer_name;
  const filteredProfiles = useMemo(
    () => (customerName ? profiles.filter((profile) => profile.customer_name === customerName) : profiles),
    [customerName, profiles]
  );

  useEffect(() => {
    if (props.value && !filteredProfiles.find((profile) => profile.id === props.value)) props.onChange(undefined);
  }, [filteredProfiles]);

  if (props.readonly) return profiles.find((profile) => profile.id === props.value)?.name || '-';

  return (
    <div>
      {!customerName && <div style={{ marginBottom: '8px', color: '#666' }}>Select a customer to be able to choose a profile</div>}
      {customerName && (
        <ProfileSelectionField
          value={filteredProfiles.find((profile) => profile.id === props.value)?.name}
          options={filteredProfiles.map((profile) => ({ label: profile.name, value: profile.id }))}
          onChange={(el, val) => props.onChange(val.value)}
        />
      )}
    </div>
  );
};

export default CustomerProfilePickerWidget;
